<template>
    <div class="d-flex flex-column">
        <navigator :selectedProduct="getSelectedItem"></navigator>

         <div class="flexGrow1" style="overflow: auto;">
            <component
                :is="stepTemplate"
                :currentStep="currentStep"
                @cancelling="cancel"
                @goToStep="goToStep"
                @readyToSave="save"
                @updateBackupGroup="updateBackupGroup">
            </component>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { mapActions, mapGetters } from 'vuex'
    import ProductLoading from './ProductLoading'
    import ProductEdit from './ProductEdit'
    import ProductSchedule from './ProductSchedule'
    import ProductPrices from './ProductPrices'
    import ProductExtras from './ProductExtras'
    import ProductResources from './ProductResources'
    import ProductChannels from './ProductChannels'
    import ProductPickups from './ProductPickups'
    import Navigator from './ProductNavigator'

    // mixins
    import {productMixin} from '@/mixins/product'

    export default {
        mixins: [
            productMixin
        ],
        data: function() {
            return {
                stepTemplate: 'ProductLoading',
                currentStep: 1,
                productBackup: null,
            }
        },
        created: function() {
            if (this.getSelectedItem) {
                // if user comes from inventory
                this.downloadProduct(this.getSelectedItem.id)
            } else if(this.$route.params.id){
                this.downloadProduct(this.$route.params.id)
            } else {
                this.stepTemplate = 'ProductEdit';
            }
        },
        computed: {
            ...mapGetters([
                'getSelectedItem',
                'getClonedItem',
                'account',
                'getAvailabilityTypes'
            ]),
            availabilityTypes: function () {
                return this.getAvailabilityTypes
            }
        },
        methods: {
            ...mapActions([
                'setSelectedItem',
                'clearSelectedItem',
                'updateClonedItem',
                'addItem',
                'updateItem',
                'flushEvents',
                'refreshAccountData',
                'setSelectedProduct',
                'openModal'
            ]),
            downloadProduct: function(productId){
                axios.get('/api/inventory/GetProductById',{
                    params: {
                        supplierId: this.account.supplierId,
                        productId: productId
                    }
                }).then(response => {
                    if (response && response.status === 200 && response.data) {
                        this.productBackup = JSON.parse(JSON.stringify(response.data));
                        this.updateClonedItem(response.data);
                        this.setSelectedProduct(response.data);
                        this.form = response.data;
                        this.stepTemplate = 'ProductEdit';
                        this.$forceUpdate();
                    }
                })
            },
            updateBackupGroup: function (downloadedGroups) {
                this.$set(this.productBackup, 'groups', this.productBackup.groups.concat(downloadedGroups))
            },
            changeCurrentStep: function(step) {
                let template = 'ProductEdit';

                this.currentStep = step;

                switch (step) {
                    case 1:
                        template = 'ProductEdit';
                        break;

                    case 2:
                        template = 'ProductSchedule';
                        break;

                    case 3:
                        template = 'ProductExtras';
                        break;

                    case 4:
                        template = 'ProductChannels';
                        break;

                    case 5:
                        template = 'ProductPickups';
                        break;

                    // case 6:
                    //     template = 'ProductPickups';
                    //     break;

                    default:
                        break;
                }

                this.stepTemplate = template;
            },
            cancel: function() {
                this.clearSelectedItem();

                this.$router.push({ name: 'inventory' });
            },
            goToStep: function(data) {
                if (!data.$invalid) {
                    this.currentStep = data.step;

                    // console.log('Going to step ', data.step, ' with', JSON.stringify(data.form));

                    this.updateClonedItem(data.form);
                    this.changeCurrentStep(this.currentStep);
                }
            },
            save: function(data) {

                let vm = this
                if (!data.invalid) {
                    this.updateClonedItem(data.form);

                    //save resources inside each schedule
                    data.form.groups.map(group => {
                        group.components = data.form.extras

                        //get group dates inside each child schedule
                        group.schedules.map(schedule => {
                            schedule.dateFrom = group.dateFrom
                            schedule.dateTo = group.dateTo
                            schedule.duration = group.duration
                            schedule.isTaxIncludedInPrice = group.tax
                        })

                        group.productGenderPrices.map(productGenderPrice => {
                            productGenderPrice.isTaxIncludedInPrice = group.productGenderPrices[0].isTaxIncludedInPrice
                        })
                    })

                    // Check other product changes to show on the "changes" resume popup
                    this.checkProductChanges(data)



                    if (this.getSelectedItem) {
                        if(
                            this.getClonedItem.showApplyAllEventQuestion == true
                            // this.getClonedItem.updateFlags.schedule ||
                            // this.getClonedItem.changes && this.getClonedItem.changes.details && this.getClonedItem.changes.details.length > 0 ||
                            // this.getClonedItem.changes && this.getClonedItem.changes.salesChannels && this.getClonedItem.changes.salesChannels.length > 0 ||
                            // this.getClonedItem.changes && this.getClonedItem.changes.addedGroups && this.getClonedItem.changes.addedGroups.length > 0 ||
                            // this.getClonedItem.changes && this.getClonedItem.changes.removedGroups && this.getClonedItem.changes.removedGroups.length > 0
                        ){
                            this.openModal('ProductSaveChanges')
                        } else {
                            //save product
                            this.updateProduct(this.getClonedItem)
                        }

                    } else {
                        Vue.toasted.info('Saving product');
                        this.addItem({
                            object: 'product',
                            action: 'create',
                            table: 'products',
                            fields: { supplierId: this.account.supplierId, product: data.form }
                        }).then((response) => {
                            if(response && response.status == 200){
                                this.closeProduct();
                            }
                        }).catch((response) => {

                        });
                    }

                }
            },
            checkProductChanges: function (input) {
                if(!this.getClonedItem.id){
                    return false
                }

                let editedProduct = input.form

                // initialize changes object
                this.$set(editedProduct, 'changes', {
                    details:[],
                    salesChannels:[],
                    addedGroups:[],
                    removedGroups:[],
                })

                // Booking Question
                if(this.productBackup.bookingQuestion != editedProduct.bookingQuestion){
                    // activate popup
                    this.getClonedItem.showApplyAllEventQuestion = true
                    this.pushChangeToArray(
                        editedProduct.changes.details,
                        'Booking Question',
                        'bookingQuestion',
                        this.productBackup.bookingQuestion,
                        editedProduct.bookingQuestion,
                        this.productBackup.bookingQuestion,
                        editedProduct.bookingQuestion,
                    )
                }

                // Booking Question Active
                if(this.productBackup.bookingQuestionIsActive != editedProduct.bookingQuestionIsActive){
                    // activate popup
                    this.getClonedItem.showApplyAllEventQuestion = true
                    this.pushChangeToArray(
                        editedProduct.changes.details,
                        'Booking question is Active',
                        'bookingQuestionIsActive',
                        this.productBackup.bookingQuestionIsActive == true? 'Yes':'No',
                        editedProduct.bookingQuestionIsActive == true? 'Yes':'No',
                        this.productBackup.bookingQuestionIsActive,
                        editedProduct.bookingQuestionIsActive,
                    )
                }

                // Booking Question Mandatory
                if(this.productBackup.bookingQuestionIsMandatory != editedProduct.bookingQuestionIsMandatory){
                    // activate popup
                    this.getClonedItem.showApplyAllEventQuestion = true
                    this.pushChangeToArray(
                        editedProduct.changes.details,
                        'Booking question is Mandatory',
                        'bookingQuestionIsMandatory',
                        this.productBackup.bookingQuestionIsMandatory == true? 'Yes':'No',
                        editedProduct.bookingQuestionIsMandatory == true? 'Yes':'No',
                        this.productBackup.bookingQuestionIsMandatory,
                        editedProduct.bookingQuestionIsMandatory,
                    )
                }

                // Location
                if(this.productBackup.location != editedProduct.location){
                    this.pushChangeToArray(
                        editedProduct.changes.details,
                        'Location',
                        'location',
                        this.productBackup.location,
                        editedProduct.location,
                        this.productBackup.location,
                        editedProduct.location,
                    )
                }

                // Schedule - Availability Type
                if(this.productBackup.availabilityType != editedProduct.availabilityType){
                    let newValNiceName = this.availabilityTypes.find(type => {return type.value == this.productBackup.availabilityType}).label;
                    let oldValNiceName = this.availabilityTypes.find(type => {return type.value == editedProduct.availabilityType}).label;
                    this.pushChangeToArray(
                        editedProduct.changes.details,
                        'Availability Type',
                        'availabilityType',
                        newValNiceName,
                        oldValNiceName,
                        this.productBackup.availabilityType,
                        editedProduct.availabilityType,
                    )
                }

                // Schedule - Capacity (if "Fixed Limit")
                if(this.productBackup.capacity != editedProduct.capacity){
                    this.pushChangeToArray(
                        editedProduct.changes.details,
                        'Capacity',
                        'capacity',
                        this.productBackup.capacity,
                        editedProduct.capacity,
                        this.productBackup.capacity,
                        editedProduct.capacity,
                    )
                }

                // Schedule - Virtual Roster
                if(this.productBackup.productShareType != editedProduct.productShareType){
                    this.pushChangeToArray(
                        editedProduct.changes.details,
                        'Virtual Roster',
                        'productShareType',
                        this.productBackup.productShareType == 2?'Yes':'No',
                        editedProduct.productShareType == 2?'Yes':'No',
                        this.productBackup.productShareType,
                        editedProduct.productShareType,
                    )
                }

                // Sales Channels
                for (let bkpSalesChannel of this.productBackup.channelCommissions) {
                    let actualSalesChannel = editedProduct.channelCommissions.find(ss => {return ss.channelId == bkpSalesChannel.channelId})
                    if(bkpSalesChannel.isActive != actualSalesChannel.isActive){

                        this.pushChangeToArray(
                            editedProduct.changes.salesChannels,
                            actualSalesChannel.channelName,
                            'salesChannel'+actualSalesChannel.channelId,
                            bkpSalesChannel.isActive == true?'Open':'Closed',
                            actualSalesChannel.isActive == true?'Open':'Closed',
                            bkpSalesChannel.isActive,
                            actualSalesChannel.isActive,
                        )
                    }
                }

                // added groups - disabled
                // for (let group of editedProduct.groups) {
                //     if(group.id == null){
                //         this.pushChangeToArray(
                //             editedProduct.changes.addedGroups,
                //             'Added Group',
                //             'addedGroup',
                //             null,
                //             group.label,
                //             null,
                //             group,
                //         )
                //     }
                // }

                // removed groups
                for (let bkpGroup of this.productBackup.groups) {

                    // check if bkpGroup still exists on editedProduct
                    let stillExists = editedProduct.groups.find(editedGroup => {return editedGroup.id == bkpGroup.id})
                    console.log(`Looking for group: ${bkpGroup.label} | stillExists: ${stillExists} | typeOf stillExists ${typeof stillExists}`);
                    if(typeof stillExists != "object"){
                        console.log('Setting this group as deleted '+bkpGroup.label);
                        this.pushChangeToArray(
                            editedProduct.changes.removedGroups,
                            'Removed Group',
                            'removedGroup',
                            bkpGroup.label,
                            null,
                            bkpGroup,
                            null,
                            true
                        )
                    }
                }

            },
            updateProduct: function (form) {
                Vue.toasted.info('Saving product');
                this.updateItem({
                    object: 'product',
                    action: 'edit',
                    table: 'products',
                    fields: { supplierId: this.account.supplierId, product: form }
                }).then((response) => {
                    if(response && response.status == 200){
                        this.closeProduct();
                    }
                }).catch((response) => {

                });
            },
            closeProduct: function() {
                // Clear both selectedProduct and clonedProduct
                this.clearSelectedItem();
                this.flushEvents();
                this.$router.push({ name: 'inventory' });
            }
        },
        components: {
            ProductLoading,
            ProductEdit,
            ProductSchedule,
            ProductPrices,
            ProductExtras,
            ProductResources,
            ProductChannels,
            ProductPickups,
            Navigator,
        }
    }
</script>

<style lang="scss">
    .new-product {
        height: auto;
        overflow-x: hidden;
        overflow-y: auto;
    }
</style>



// WEBPACK FOOTER //
// ProductForm.vue?bfab386a